<template>
  <div class="login_page fillcontain">
    <div id="particles"></div>
    <section class="form_contianer" v-show="showLogin">
      <div class="manage_tip">
        <img src="~@/assets/img/loginLogo.png" alt />
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="用户名">
            <i slot="prefix" class="el-icon-user login-icon"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            placeholder="密码"
            v-model="loginForm.password"
            @keyup.enter.native="submitForm"
          >
            <i slot="prefix" class="el-icon-lock login-icon"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()" class="submit_btn">登录</el-button>
        </el-form-item>
        <div class="tips">Copyright © 2019小城达人管理系统</div>
      </el-form>
    </section>
  </div>
</template>
<script>
import particles from "particles.js";
import particlesJson from "../assets/style/particles.json";
import { loginUser, serverStatus } from "config/api.js";

export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      showLogin: true
    };
  },
  mounted() {
    particlesJS("particles", particlesJson);//加载particles插件
  },
  methods: {
    submitForm() {
      //登录
      if (this.loginForm.username && this.loginForm.password) {
        this.$post(loginUser, {
          username: this.loginForm.username,
          password: this.loginForm.password,
          verifyCode: 1234
        })
          .then(res => {
            console.log("success", res);
            localStorage.setItem("xctoken", res.token);
            localStorage.setItem("uid", res.user_id);
            localStorage.setItem("username", this.loginForm.username);
            this.$store.commit("saveAdminInfo", this.loginForm);
            let menu = res.menu;
            let page = [];
            for (let i in menu) {//遍历返回的路由，筛选页面路由
              delete menu[i].operate;
              menu[i].id = i + 1;
              for (let a = 0; a < menu[i].page.length; a++) {
                if (menu[i].page[a].check == false) {
                  menu[i].page.splice(a, 1);
                  a--;
                } else {
                  page.push(menu[i].page[a].path);
                }
              }
            }
            // page.push('/','/401','/modifyPassword','/workBench')
            localStorage.setItem("userNav", JSON.stringify(menu));//缓存导航栏数据
            localStorage.setItem("page", JSON.stringify(page));//缓存权限页面数据
            // this.$store.commit("userNav", menu);
            // this.checkServerStatus(page);
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push(page[0]);
          })
          .catch(err => {
            console.log("err", err);x
            // this.$message({
            //   message: "登录失败",
            //   type: "error"
            // });
          });
      } else {
        this.$notify.error({
          title: "错误",
          message: "请输入正确的用户名密码",
          offset: 100
        });
        return false;
      }
    },
    checkServerStatus(page) {
      //检测服务状态是否正常
      this.$post(serverStatus, {})
        .then(res => {
          console.log("success", res);

          if (res.service_status == 0) {
            
          } else {
            this.$router.push("/renew");
          }
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }
};
</script>
<style scoped>
#particles {
  position: absolute;
  width: 100%;
  height: 100%;
  /* background-color: #b61924; */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}
.fillcontain {
  position: absolute;
  height: 100%;
  width: 100%;
  background: #2a3542;
  /* background: url("~@/assets/img/background.png") center center no-repeat; */
  /* background-size: cove */
}
.manage_tip {
  margin-bottom: 30px;
  font-size: 20px;
  font-weight: bold;
}
.manage_tip img {
  width: 320px;
  height: auto;
}

.form_contianer {
  width: 400px;
  /* height: 210px; */
  padding: 25px;
  border-radius: 5px;
  text-align: center;
  /* background-color: #fff; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.el-form{
  padding: 45px 45px 25px;
  background: #fff;
  border-radius: 5px;
}
.submit_btn {
  width: 100%;
  font-size: 16px;
  margin-top: 20px;
}
.el-input__prefix {
  width: 40px;
  background: #1890ff;
}
.login-icon {
  font-size: 19px;
  color: #666;
  /* padding-left: 5px */
}
.tips {
  font-size: 14px;
  color: #666;
}
</style>




// WEBPACK FOOTER //
// src/pages/login.vue